// extracted by mini-css-extract-plugin
export var domain_card = "domaincard-module--domain_card--uAPgK";
export var domain_img = "domaincard-module--domain_img--GM+p4";
export var domain_title = "domaincard-module--domain_title--eQThx";
export var domain_body = "domaincard-module--domain_body--67y7q";
export var domain_container = "domaincard-module--domain_container--031p5";
export var domain_svg_top = "domaincard-module--domain_svg_top--5KuzI";
export var domain_svg_middle = "domaincard-module--domain_svg_middle--MdA-y";